// PROTOTYPE (hero shapes): the worker that works out the mark's places
// (markTargets.worker.js), on its own so tests, which have no workers, can
// stand in for it.
export const startMarkWorker = () => new Worker(new URL("./markTargets.worker.js", import.meta.url));
